import { render, staticRenderFns } from "./EditConfig.vue?vue&type=template&id=c71a7392&scoped=true&"
import script from "./EditConfig.vue?vue&type=script&lang=ts&"
export * from "./EditConfig.vue?vue&type=script&lang=ts&"
import style0 from "./EditConfig.vue?vue&type=style&index=0&id=c71a7392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71a7392",
  null
  
)

export default component.exports